import React from 'react';

const UserSettingsMessage = () => <div>UserSettingsMessage Component</div>;

export default UserSettingsMessage;
